import React from "react";
import * as custMiscService from "../../services/kyc/kyc-service";
import * as masterService from "../../services/master/master-service";
import * as Loader from "../../common/common";
import DropDown from "../../components/form-controls/dropdown";
import { Authorize } from "../../components/authorize";
import { commonDownloadPdf } from "../../common/download-pdf";
import * as commonDownloadPdfService from "../../services/pdf/download_pdf_service";
import { withRouterProps } from "../../common/hocs";

const { v4: uuidv4 } = require("uuid");

class CustomerMisc extends Authorize {
  constructor(props) {
    super(props);
    this.onEdit = this.onEdit.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);

    this.state = {
      clientId: this.props.clientId,
      userType: this.props.clientType,
      customer: {
        clientId: this.props.clientId,
        custId: "",
        loadedGRF: "CFS Gate In Date",
        emptyGRF: "Destuff Date",
        exportCS: "Grid Wise",
        exportCSF: "Week Wise",
        importCSF: "Week Wise",
        tdsAmount: "Amount",
        financeLedgerCode: "",
        kycStatus: "",
      },
      loadedGRFData: "",
      emptyGRFData: "",
      exportCSData: "",
      exportCSFData: "",
      importCSFData: "",
      tdsAmountData: "",
      financeLedgerCodeData: "",
      validationErrors: {},
      msg: "",
      deleteMsg: "",
      error: "",
    };
  }

  async downloadPdf(clientId) {
    let data = {
      clientId: clientId,
    };
    let {
      response,
      err,
    } = await commonDownloadPdfService.downloadCustomerMiscellaneous(data);
    if (err) {
    } else if (response.data) {
      commonDownloadPdf(response.data, "CustomerMiscellaneous_" + clientId);
    }
  }

  onEdit(id, e) {
    let editData = this.state.data.filter((ele) => {
      return ele.bankId === id;
    });

    if (this.state.showModel === false) {
      this.setState({
        bank: editData[0],
        showModel: !this.state.showModel,
      });
    } else {
      this.setState({
        bank: editData[0],
      });
    }
  }
  onChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({
      customer: {
        ...this.state.customer,
        [name]: value,
      },
    });
  }
  onClear() {
    this.setState({
      customer: {
        ...this.state.customer,
        loadedGRF: "CFS Gate In Date",
        emptyGRF: "Destuff Date",
        exportCS: "Grid Wise",
        exportCSF: "Week Wise",
        importCSF: "Week Wise",
        tdsAmount: "Amount",
      },
      validationErrors: {},
      msg: "",
      deleteMsg: "",
      error: "",
    });
  }
  async onSubmit(id, e) {
    Loader.showLoader();
    e.preventDefault();
    if (id === "prev") {
      this.props.router.navigate(
        "/kycs/" +
          this.state.clientId +
          "/" +
          this.state.userType +
          "/analysiscustomer"
      );
    } else {
      if (id) {
        this.state.customer.custId = id;
      } else {
        this.state.customer.custId = uuidv4();
      }
      let { response, err } = await custMiscService.saveCustomerMisc(
        this.state.customer
      );
      Loader.hideLoader();

      let msg = "";
      if (err) {
      } else if (response && response.data && response.data.err) {
      } else {
        if (response.data.success) {
          msg = response.data.msg;
        } else {
          msg = "Error while deleting!";
        }
        this.setState({
          msg: msg,
          error: "",
        });
      }
      Loader.hideLoader();
    }
  }
  async getCustomerMisc() {
    Loader.showLoader();
    let { response, err } = await custMiscService.getCustomerMisc(
      this.state.clientId
    );
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      if (response.data.custId) {
        this.setState({
          customer: response.data,
        });
      } else {
        this.setState({
          customer: {
            ...this.state.customer,
            financeLedgerCode: response.data.financeLedgerCode,
            kycStatus: response.data.kycStatus,
          },
        });
      }
    }
  }

  async componentDidMount() {
    this.getCustomerMisc();
    Loader.showLoader();
    let loadedGRFData = await masterService.getMastersByGroup("ImportRent");
    let emptyGRFData = await masterService.getMastersByGroup("ExportRent");
    let exportCSData = await masterService.getMastersByGroup("ExportCargo");
    let exportCSFData = await masterService.getMastersByGroup("ExportFactor");
    let importCSFData = await masterService.getMastersByGroup("ImportFactor");
    let tdsAmountData = await masterService.getMastersByGroup("TDSOnAmount");

    this.setState(
      {
        loadedGRFData:
          loadedGRFData &&
          loadedGRFData.response &&
          loadedGRFData.response.data,
        emptyGRFData:
          emptyGRFData && emptyGRFData.response && emptyGRFData.response.data,
        exportCSData:
          exportCSData && exportCSData.response && exportCSData.response.data,
        exportCSFData:
          exportCSFData &&
          exportCSFData.response &&
          exportCSFData.response.data,
        importCSFData:
          importCSFData &&
          importCSFData.response &&
          importCSFData.response.data,
        tdsAmountData:
          tdsAmountData &&
          tdsAmountData.response &&
          tdsAmountData.response.data,
      },
      () => {
        Loader.hideLoader();
      }
    );
  }
  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    return (
      <div className="container">
        <div className="row">
          <div>&nbsp;</div>
          <div className="col-md-12">
            <button
              className="float-right btn btn-md btn-info"
              title="Download PDF"
              onClick={this.downloadPdf.bind(this, this.state.clientId)}
            >
              <i className="fa fa-download"></i> PDF{" "}
            </button>
          </div>
          {this.state.msg && (
            <div className="alert alert-success">{this.state.msg}</div>
          )}
          <div className="col-md-10 divWidth" style={{ marginLeft: "80px" }}>
            <form>
              <div className="card p-4">
                <h3 style={{ textAlign: "center" }}>Customer Miscellaneous</h3>
                <div className="row">
                  <div className="col-sm-6">
                    <DropDown
                      label="Import Loaded Ground Rent Form"
                      name="loadedGRF"
                      required={true}
                      value={this.state.customer.loadedGRF || ""}
                      error={this.state.validationErrors.loadedGRFError}
                      onChange={this.onChange}
                      defaultItem={null}
                      list={this.state.loadedGRFData}
                      valProp="name"
                      textProp="name"
                    />
                  </div>
                  <div className="col-sm-6">
                    <DropDown
                      label="Empty Ground Rent Form"
                      name="emptyGRF"
                      required={true}
                      value={this.state.customer.emptyGRF || ""}
                      error={this.state.validationErrors.emptyGRFError}
                      onChange={this.onChange}
                      defaultItem={null}
                      list={this.state.emptyGRFData}
                      valProp="name"
                      textProp="name"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <DropDown
                      label="Export Cargo Storage"
                      name="exportCS"
                      required={true}
                      value={this.state.customer.exportCS || ""}
                      error={this.state.validationErrors.exportCSError}
                      onChange={this.onChange}
                      defaultItem={null}
                      list={this.state.exportCSData}
                      valProp="name"
                      textProp="name"
                    />
                  </div>
                  <div className="col-sm-6">
                    <DropDown
                      label="Export Cargo Storage Factor"
                      name="exportCSF"
                      required={true}
                      value={this.state.customer.exportCSF || ""}
                      error={this.state.validationErrors.exportCSError}
                      onChange={this.onChange}
                      defaultItem={null}
                      list={this.state.exportCSFData}
                      valProp="name"
                      textProp="name"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <DropDown
                      label="Import Cargo Storage Factor"
                      name="importCSF"
                      required={true}
                      value={this.state.customer.importCSF || ""}
                      error={this.state.validationErrors.importCSFError}
                      onChange={this.onChange}
                      defaultItem={null}
                      list={this.state.importCSFData}
                      valProp="name"
                      textProp="name"
                    />
                  </div>
                  <div className="col-sm-6">
                    <DropDown
                      label="TDS Amount"
                      name="tdsAmount"
                      required={true}
                      value={this.state.customer.tdsAmount || ""}
                      error={this.state.validationErrors.tdsAmountError}
                      onChange={this.onChange}
                      defaultItem={null}
                      list={this.state.tdsAmountData}
                      valProp="name"
                      textProp="name"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Finance Ledger Code</label>
                      <input
                        type="text"
                        value={
                          this.state.customer.financeLedgerCode
                            ? this.state.customer.financeLedgerCode
                            : ""
                        }
                        name="financeLedgerCode"
                        readOnly={true}
                        className="form-control"
                        placeholder="Finance Ledger Code"
                        onChange={this.onChange}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={this.onSubmit.bind(this, "prev")}
                  >
                    Previous
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-primary"
                    type="submit"
                    onClick={this.onSubmit.bind(
                      this,
                      this.state.customer.custId
                    )}
                  >
                    Save
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={this.onClear}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

// Custom HOC to inject router props to use React Router v6 hooks in class components
export default withRouterProps(CustomerMisc);